import "./DataCollection.css";
import Description from "./Inputs/Description";
import { useTranslation } from "react-i18next";
import InputRowGroup from "./Inputs/InputRowGroup";
import InputRow from "./Inputs/InputRow";
import DropdownInput from "./Inputs/DropdownInput";
import { handleChange } from "../Utils/DataCollectionUtils";
import DateInput from "./Inputs/DateInput";
import NumberInput from "./Inputs/NumberInput";
import { Label } from "recharts";
import BooleanInput from "./Inputs/BooleanInput";
import TextInput from "./Inputs/TextInput";
import MultilineInputRow from "./Inputs/MultilineInputRow";
import { useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import {
  calculateAge,
  calculateAgeOfYoungestBeneficiary,
  calculateApproximateNetWorth,
  calculateTimeHorizon,
  calculateTotalFinancialAssets,
  calculateTotalInvestmentAssets,
  calculateTotalMonthlyExpenses,
  calculateTotalOtherAssets,
  isMaternityForm,
} from "../Utils/KYCUtils";

import { isLanguageEnglish } from "../PDFGeneration/PDFGenerationUtils";

import { displayCurrency } from "../Utils/FormattingUtils";
import useFocusRef from "../Hooks/useFocusRef";

// @TODO: Add second plan
const KnowYourClientDataCollection = ({ state }) => {
  const focusRef = useRef();
  const params = useParams();
  const { t, i18n } = useTranslation();

  const kyc = state.knowYourClient;
  const setKyc = state.setKnowYourClient;

  const subscriber = state.subscriber;
  const setSubscriber = state.setSubscriber;

  const common = state.common;
  const setCommon = state.setCommon;

  const dependant = state.dependant;
  const setDependant = state.setDependant;

  const dependant2 = state.dependant2;
  const setDependant2 = state.setDependant2;

  const dependant3 = state.dependant3;
  const setDependant3 = state.setDependant3;

  const dependant4 = state.dependant4;
  const setDependant4 = state.setDependant4;

  const dependant5 = state.dependant5;
  const setDependant5 = state.setDependant5;

  const jointSubscriber = state.jointSubscriber;
  const setJointSubscriber = state.setJointSubscriber;

  const application = state.application;
  const setApplication = state.setApplication;

  const beneficiary = state.beneficiary;
  const setBeneficiary = state.setBeneficiary;

  const spaceBetweenStyle = {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
  };

  const yearsEducationalSupport = [
    { label: "N/A", value: "N/A" },
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
  ];

  const englishOptionsdrReason = [
    {
      label: t(
        "The subscriber(s) wish to save for post-secondary education and the proposed contributions are within CEFI’s affordability guidelines",
      ),
      value: t(
        "The subscriber(s) wish to save for post-secondary education and the proposed contributions are within CEFI’s affordability guidelines",
      ),
    },
    {
      label: t(
        "The subscriber(s) wish to save for post-secondary education and the proposed plan is onside risk tolerance",
      ),
      value: t(
        "The subscriber(s) wish to save for post-secondary education and the proposed plan is onside risk tolerance",
      ),
    },
    {
      label: t("Other (Please note in the KYC Notes Section)"),
      value: t("Other (Please note in the KYC Notes Section)"),
    },
  ];

  const translatedOptionsdrReason = [
    {
      label: t(
        "The subscriber(s) wish to save for post-secondary education and the proposed contributions are within CEFI’s affordability guidelines",
      ),
      value: t(
        "The subscriber(s) wish to save for post-secondary education and the proposed contributions are within CEFI’s affordability guidelines",
      ),
    },
    {
      label: t(
        "The subscriber(s) wish to save for post-secondary education and the proposed plan is onside risk tolerance",
      ),
      value: t(
        "The subscriber(s) wish to save for post-secondary education and the proposed plan is onside risk tolerance",
      ),
    },
    {
      label: t("Other - Please note in the KYC Notes Section"),
      value: t("Other - Please note in the KYC Notes Section"),
    },
  ];

  const englishOptionsObjective = [
    {
      label: t("Education Savings"),
      value: t("Education Savings"),
    },
    {
      label: t("Other (Specify in Notes)"),
      value: t("Other (Specify in Notes)"),
    },
  ];

  const translatedOptionsObjective = [
    {
      label: t("\u00c9pargne \u00e9tudes"),
      value: t("\u00c9pargne \u00e9tudes"),
    },
    {
      label: t("Autre (sp\u00e9cifier dans les notes)"),
      value: t("Autre (sp\u00e9cifier dans les notes)"),
    },
  ];
  function _displayCurrency(value, decimals = 0) {
    if (isNaN(value)) {
      return "";
    }
    return displayCurrency(value, i18n.language, decimals);
  }

  //useFocusRef allows us to scroll the element we set the ref to into view
  useFocusRef(focusRef);

  if (state.application.masterApplicationId) {
    return (
      <InputRowGroup
        label={t(
          "Know Your Client details must be changed on the Primary enrolment of this Family Enrolment.",
        )}
      >
        <Link
          to={
            "/enrolment/" +
            state.application.masterApplicationId +
            "/Know your Client/" +
            (params.item || "")
          }
        >
          Go to primary enrolment
        </Link>
      </InputRowGroup>
    );
  } else {
    return (
      <form>
        <InputRowGroup label={t("Know your Client")}>
          {/*Know your client fourm type

                        Options:
                        Maternity: 1,
                        Normal: 0
                    */}
          <InputRow label={t("Know Your Client Form Type")}>
            <DropdownInput
              state={kyc}
              onChange={handleChange(setKyc)}
              name="kycFormType"
              options={[
                { label: [t("Maternity")], value: 1 },
                {
                  label: [t("Normal")],
                  value: 0,
                },
              ]}
            ></DropdownInput>
          </InputRow>

          {/*Deposits*/}
          {/* <InputRow label={t("Deposits")}>
                        <NumberInput
                            name={"deposits"}
                            state={kyc}
                            onChange={handleChange(setKyc)}
                            onlyAllowPositive={true}
                            onlyAllowInteger={true}
                            autoFocus={params.item === "deposits"}
                            annotationIcon={"$"}
                            maxLength={10}
                        />
                    </InputRow> */}
        </InputRowGroup>

        <InputRowGroup label={t("Financial Information")}>
          {/*Cash and Liquid*/}
          <InputRow label={t("Cash and Other Liquid Investments")}>
            <NumberInput
              name={"cashAndLiquid"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              annotationIcon={"$"}
            />
          </InputRow>
        </InputRowGroup>

        <InputRowGroup label={t("Investment Assets (Medium to Long-Term)")}>
          {/*Securities*/}
          <InputRow label={t("Securities (Stocks/Bonds/Mutual Funds/ETFs)")}>
            <NumberInput
              name={"securities"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              annotationIcon={"$"}
              maxLength={10}
            />
          </InputRow>

          <InputRow label={t("Registered Accounts (RRSP & TFSA)")}>
            <NumberInput
              name={"registeredAccountsRESPAndTFSA"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              annotationIcon={"$"}
            />
          </InputRow>

          <InputRow label={t("Registered Accounts (RESPs)")}>
            <NumberInput
              name={"RegisteredAccountsRESPs"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              annotationIcon={"$"}
            />
          </InputRow>

          <InputRow label={t("Other")}>
            <NumberInput
              name={"investmentAssetsOther"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              annotationIcon={"$"}
            />
          </InputRow>

          <InputRow label={t("Total Investment Assets")}>
            {_displayCurrency(calculateTotalInvestmentAssets(kyc))}
          </InputRow>
        </InputRowGroup>

        <InputRowGroup label={t("Other Assets (Real & Personal Property)")}>
          <InputRow label={t("Principal Residence (Equity)")}>
            <NumberInput
              name={"principalResidenceEquity"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              annotationIcon={"$"}
            />
          </InputRow>

          <InputRow label={t("Other Real Estate (Equity)")}>
            <NumberInput
              name={"otherRealEstateEquity"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              annotationIcon={"$"}
            />
          </InputRow>

          <InputRow label={t("Vehicles")}>
            <NumberInput
              name={"otherAssetsVehicles"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              annotationIcon={"$"}
            />
          </InputRow>

          <InputRow label={t("Collectibles/Art/Valuables")}>
            <NumberInput
              name={"collectablesArtValuables"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              annotationIcon={"$"}
            />
          </InputRow>

          {/*Other Assets*/}
          <InputRow label={t("Other Assets")}>
            <NumberInput
              name={"otherAssets"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              annotationIcon={"$"}
              maxLength={10}
            />
          </InputRow>

          <InputRow label={t("Total Other Assets")}>
            {_displayCurrency(calculateTotalOtherAssets(kyc))}
          </InputRow>

          {/*Total Financial Assets

                    TODO fix string concat?
                    */}
          {/* <InputRow label={t("Total Financial Assets")}>
                        {_displayCurrency(calculateTotalFinancialAssets(kyc))}
                    </InputRow> */}

          {/* liabilities */}
          <InputRow label={t("Liabilities")}>
            <NumberInput
              name={"liabilities"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              annotationIcon={"$"}
              maxLength={10}
            />
          </InputRow>

          {/*Approximate Net Worth*/}
          <InputRow label={t("Net Worth (Assets - Liabilities)")}>
            {_displayCurrency(calculateApproximateNetWorth(kyc))}
          </InputRow>

          {/* is existing subscriber */}
          <InputRow label={t("Existing CET Subscriber")}>
            <BooleanInput
              label={t("Yes")}
              name={"existingSubscriber"}
              state={kyc}
              onChange={handleChange(setKyc)}
            />
          </InputRow>

          {/*  vehicles owned or being paid for dropdown  */}
          <InputRow label={t("Vehicle(s) owned or being paid for?")}>
            <DropdownInput
              state={kyc}
              onChange={handleChange(setKyc)}
              name="vehicles"
              useDefaultValue={false}
              defaultPlaceholder={t("select vehicles")}
              options={[
                { label: "0", value: "0" },
                { label: "1", value: "1" },
                {
                  label: "2",
                  value: "2",
                },
                { label: "3+", value: "3+" },
              ]}
            >
              {/*  TODO determine how stored  */}
            </DropdownInput>
          </InputRow>

          {kyc.kycFormType == 1 && (
            <InputRow
              label={t("Vehicle(s) owned or being paid for? (After Mat Leave)")}
            >
              <DropdownInput
                state={kyc}
                onChange={handleChange(setKyc)}
                name="vehiclesAfterMat"
                useDefaultValue={false}
                defaultPlaceholder={t("select vehicles")}
                options={[
                  { label: "0", value: "0" },
                  { label: "1", value: "1" },
                  { label: "2", value: "2" },
                  { label: "3+", value: "3+" },
                ]}
              />
            </InputRow>
          )}
        </InputRowGroup>

        {/*  subscriber  */}
        <InputRowGroup label={t("Subscriber")}>
          {/*  Investment Experience

                        Options:
                        None,
                        Limited,
                        Experienced
                    */}
          <InputRow label={t("Investment Experience")}>
            <DropdownInput
              state={subscriber}
              useDefaultValue={false}
              defaultPlaceholder={t("select experience")}
              onChange={handleChange(setSubscriber)}
              name="investmentExperience"
              options={[
                { label: t("None"), value: "None" },
                {
                  label: t("Limited"),
                  value: "Limited",
                },
                {
                  label: t("Experienced"),
                  value: "Experienced",
                },
              ]}
              innerRef={
                params.item === "subscriber.investmentExperience"
                  ? focusRef
                  : null
              }
            ></DropdownInput>
          </InputRow>

          {/*  Investment Types  */}
          {/*TODO add description text or make presets*/}
          {/*<InputRow label={t("Investment Types")}>
            <TextInput
              name={"investmentTypes"}
              state={subscriber}
              placeholder={t("Investment Types")}
              onChange={handleChange(setSubscriber)}
              maxLength={20}
            />
          </InputRow>*/}

          {/* Occupation */}
          <InputRow label={t("Occupation")}>
            <TextInput
              name={"occupation"}
              placeholder={t("Occupation")}
              state={subscriber}
              onChange={handleChange(setSubscriber)}
              maxLength={20}
            />
          </InputRow>

          {/*  Employer  */}
          <InputRow label={t("Employer")}>
            <TextInput
              name={"employer"}
              placeholder={t("Employer")}
              state={subscriber}
              onChange={handleChange(setSubscriber)}
              maxLength={40}
            />
          </InputRow>

          {/*  If Quebec:  */}
          {state.agent.province === "PQ" && ( // TODO check if this is the correct way to check for Quebec
            <>
              {/*  Employer Address  */}
              <InputRow label={t("Employer Address")}>
                <TextInput
                  name={"employerAddress"}
                  placeholder={t("Employer Address")}
                  state={subscriber}
                  onChange={handleChange(setSubscriber)}
                  maxLength={50}
                />
              </InputRow>

              {/*  Employer Industry  */}
              <InputRow label={t("Employer Industry")}>
                <TextInput
                  name={"employerIndustry"}
                  placeholder={t("Employer Industry")}
                  state={subscriber}
                  onChange={handleChange(setSubscriber)}
                  maxLength={20}
                />
              </InputRow>
            </>
          )}
        </InputRowGroup>

        {common.subscriber2Include && (
          <InputRowGroup label={t("Joint Subscriber")}>
            {/*  Investment Experience

                        Options:
                        None,
                        Limited,
                        Experienced
                    */}
            <InputRow label={t("Investment Experience")}>
              <DropdownInput
                state={jointSubscriber}
                useDefaultValue={false}
                defaultPlaceholder={t("select experience")}
                onChange={handleChange(setJointSubscriber)}
                name="investmentExperience"
                options={[
                  { label: t("None"), value: "None" },
                  {
                    label: t("Limited"),
                    value: "Limited",
                  },
                  {
                    label: t("Experienced"),
                    value: "Experienced",
                  },
                ]}
                innerRef={
                  params.item === "subscriber2.investmentExperience"
                    ? focusRef
                    : null
                }
              ></DropdownInput>
            </InputRow>

            {/*  Investment Types  */}
            {/*TODO add description text or make presets*/}
            {/*}
            <InputRow label={t("Investment Types")}>
              <TextInput
                name={"investmentTypes"}
                state={jointSubscriber}
                placeholder={t("Investment Types")}
                maxLength={30}
                onChange={handleChange(setJointSubscriber)}
              />
            </InputRow>
*/}
            {/* Occupation */}
            <InputRow label={t("Occupation")}>
              <TextInput
                name={"occupation"}
                placeholder={t("Occupation")}
                state={jointSubscriber}
                maxLength={40}
                onChange={handleChange(setJointSubscriber)}
              />
            </InputRow>

            {/*  Employer  */}
            <InputRow label={t("Employer")}>
              <TextInput
                name={"employer"}
                placeholder={t("Employer")}
                state={jointSubscriber}
                maxLength={40}
                onChange={handleChange(setJointSubscriber)}
              />
            </InputRow>

            {/*  If Quebec:  */}
            {state.agent.province === "PQ" && ( // TODO check if this is the correct way to check for Quebec
              <>
                {/*  Employer Address  */}
                <InputRow label={t("Employer Address")}>
                  <TextInput
                    name={"employerAddress"}
                    placeholder={t("Employer Address")}
                    state={jointSubscriber}
                    maxLength={50}
                    onChange={handleChange(setJointSubscriber)}
                  />
                </InputRow>

                {/*  Employer Industry  */}
                <InputRow label={t("Employer Industry")}>
                  <TextInput
                    name={"employerIndustry"}
                    placeholder={t("Employer Industry")}
                    state={jointSubscriber}
                    maxLength={30}
                    onChange={handleChange(setJointSubscriber)}
                  />
                </InputRow>
              </>
            )}
          </InputRowGroup>
        )}

        {/*  Objectives  */}
        <InputRowGroup label={t("Objectives")}>
          {/*  Risk Tolerance

                    Options:
                    Low,
                    Medium,
                    High
                     */}
          <InputRow label={t("Risk Tolerance")}>
            <DropdownInput
              state={kyc}
              useDefaultValue={false}
              defaultPlaceholder={t("select risk tolerance")}
              onChange={handleChange(setKyc)}
              name="riskTolerance"
              options={[
                { label: t("Low"), value: "Low" },
                {
                  label: t("Medium"),
                  value: "Medium",
                },
                { label: t("High"), value: "High" },
              ]}
              innerRef={params.item === "riskTolerance" ? focusRef : null}
            ></DropdownInput>
          </InputRow>

          {/*  Objectives

                    Options:
                    Education,
                    Other (Specify in notes),
                    */}
          <InputRow label={t("Objective")}>
            <DropdownInput
              state={kyc}
              useDefaultValue={false}
              defaultPlaceholder={t("select objective")}
              onChange={handleChange(setKyc)}
              name="objective"
              options={
                isLanguageEnglish
                  ? englishOptionsObjective
                  : translatedOptionsObjective
              }
              innerRef={params.item === "objective" ? focusRef : null}
            ></DropdownInput>
          </InputRow>
        </InputRowGroup>

        {/* Leveraging */}
        <InputRowGroup label={t("Leveraging")}>
          {/* Leveraging */}
          <InputRow label={t("Are you borrowing to invest in this plan(s)?")}>
            <BooleanInput
              label={t("Yes")}
              name={"borrowingToInvest"}
              state={common}
              onChange={handleChange(setCommon)}
            />
          </InputRow>
        </InputRowGroup>

        {/*  Estimate Monthly Income  */}
        <InputRowGroup label={t("Estimate Monthly Income")}>
          {/*  Gross and Net Income header */}
          <InputRow label={" "}>
            <div className={"row-with-headers"}>
              <div>{t("Gross")}</div>
              <div>{t("Net")}</div>
            </div>
            {/*  TODO find a more elegant way to do this.  */}
          </InputRow>

          {/*  Subscriber1 gross, net income  */}
          <InputRow label={t("Subscriber 1")}>
            <div style={{ display: "flex", gap: "10px" }}>
              <NumberInput
                name={"monthlyIncomeGross"}
                state={subscriber}
                onChange={handleChange(setSubscriber)}
                onlyAllowPositive={true}
                onlyAllowInteger={true}
                annotationIcon={"$"}
              />
              <NumberInput
                name={"monthlyIncomeNet"}
                state={subscriber}
                onChange={handleChange(setSubscriber)}
                onlyAllowPositive={true}
                onlyAllowInteger={true}
                annotationIcon={"$"}
              />
            </div>
          </InputRow>

          {/* Subscriber 2 gross, net income */}
          {common.subscriber2Include && (
            <InputRow label={t("Subscriber 2")}>
              <div style={{ display: "flex", gap: "10px" }}>
                <NumberInput
                  name={"monthlyIncomeGross"}
                  state={jointSubscriber}
                  onChange={handleChange(setJointSubscriber)}
                  onlyAllowPositive={true}
                  onlyAllowInteger={true}
                  annotationIcon={"$"}
                />
                <NumberInput
                  name={"monthlyIncomeNet"}
                  state={jointSubscriber}
                  onChange={handleChange(setJointSubscriber)}
                  onlyAllowPositive={true}
                  onlyAllowInteger={true}
                  annotationIcon={"$"}
                />
              </div>
            </InputRow>
          )}

          {/*  Temporary Income  */}
          <InputRow label={t("Temporary Income (CCB, CERB, ETC)")}>
            <NumberInput
              name={"ccbMonthlyIncomeGross"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              annotationIcon={"$"}
              maxLength={10}
            />

            {_displayCurrency(kyc.ccbMonthlyIncomeGross)}
          </InputRow>

          {/*  Other income net and gross  */}
          <InputRow label={t("Other Income")}>
            <div style={{ display: "flex", gap: "10px" }}>
              <NumberInput
                name={"otherMonthlyIncomeGross"}
                state={kyc}
                onChange={handleChange(setKyc)}
                onlyAllowPositive={true}
                onlyAllowInteger={true}
                annotationIcon={"$"}
              />
              <NumberInput
                name={"otherMonthlyIncomeNet"}
                state={kyc}
                onChange={handleChange(setKyc)}
                onlyAllowPositive={true}
                onlyAllowInteger={true}
                annotationIcon={"$"}
              />
            </div>
          </InputRow>

          {/*  Estimated Monthly Income  */}
          <InputRow label={t("Estimated Monthly Income")}>
            {/*  TODO remove money added from joint when single is selected  */}
            <div className={"row-with-headers"}>
              <div>
                {/*Gross*/}
                {_displayCurrency(
                  +subscriber.monthlyIncomeGross +
                    +jointSubscriber.monthlyIncomeGross +
                    +kyc.otherMonthlyIncomeGross,
                )}
              </div>
              <div>
                {/*Net*/}
                {_displayCurrency(
                  +subscriber.monthlyIncomeNet +
                    +jointSubscriber.monthlyIncomeNet +
                    +kyc.otherMonthlyIncomeNet,
                )}
              </div>
              {/*  TODO find a better way to do this.  */}
            </div>
          </InputRow>

          {/*  Family Yearly Gross Income (Excluding Temp)  */}
          <InputRow label={t("Family Yearly Gross Income (Excluding Temp)")}>
            {/*  TODO figure out how the family yearly gross income is calculated  */}
            <div className={"row-with-headers"}>
              <div>
                {_displayCurrency(
                  (+subscriber.monthlyIncomeGross +
                    +jointSubscriber.monthlyIncomeGross +
                    +kyc.otherMonthlyIncomeGross) *
                    12,
                )}
              </div>
            </div>
          </InputRow>
        </InputRowGroup>

        {/*  Estimate Monthly Expenses  */}
        <InputRowGroup label={t("Estimate Monthly Expenses")}>
          {/*  Payments on Loans and Debts */}
          <InputRow label={t("Payments on Loans and Debts")}>
            <NumberInput
              name={"paymentOnLoansAndDebts"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              annotationIcon={"$"}
              maxLength={10}
            />
          </InputRow>

          {/*  Mortgage / Condo fees / Rent / Property Tax */}
          <InputRow label={t("Mortgage / Condo fees / Rent / Property Tax")}>
            <NumberInput
              name={"morgageCondoFeesRent"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              annotationIcon={"$"}
              maxLength={10}
            />
          </InputRow>

          {/*  Groceries  */}
          <InputRow label={t("Groceries")}>
            <NumberInput
              name={"groceries"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              annotationIcon={"$"}
              maxLength={10}
            />
          </InputRow>

          {/*  Child Care  */}
          <InputRow label={t("Child Care")}>
            <NumberInput
              name={"childCare"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              annotationIcon={"$"}
              maxLength={10}
            />
          </InputRow>

          {/*  Clothing  */}
          <InputRow label={t("Clothing")}>
            <NumberInput
              name={"clothing"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              annotationIcon={"$"}
              maxLength={10}
            />
          </InputRow>

          {/*  Insurance (Life, Property)  */}
          <InputRow label={t("Insurance (Life, Property)")}>
            <NumberInput
              name={"insurance"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              annotationIcon={"$"}
              maxLength={10}
            />
          </InputRow>

          {/*  Utilities  */}
          <InputRow label={t("Utilities")}>
            <NumberInput
              name={"utilities"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              annotationIcon={"$"}
              maxLength={10}
            />
          </InputRow>

          {/*  Transportation  */}
          <InputRow label={t("Transportation")}>
            <NumberInput
              name={"transportation"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              annotationIcon={"$"}
              maxLength={10}
            />
          </InputRow>

          {/*  Miscellaneous (detail in notes)  */}
          <InputRow label={t("Miscellaneous (detail in notes)")}>
            <NumberInput
              name={"miscellaneous"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              annotationIcon={"$"}
              maxLength={10}
            />
          </InputRow>

          {/*  Estimated Total Expenses  */}
          <InputRow label={t("Estimated Total Expenses")}>
            {/*  TODO figure out how the estimated total expenses is calculated  */}
            {_displayCurrency(calculateTotalMonthlyExpenses(kyc))}
          </InputRow>
        </InputRowGroup>

        {/*  Estimated Disposable Income  */}
        <InputRowGroup label={t("Estimated Disposable Income")}>
          {/*  Estimated Disposable Income  */}
          <InputRow label={t("Estimated Disposable Income")}>
            {/*  TODO figure out how the estimated disposable income is calculated  */}
            {_displayCurrency(
              +subscriber.monthlyIncomeNet +
                +jointSubscriber.monthlyIncomeNet +
                +kyc.otherMonthlyIncomeNet -
                (+kyc.paymentOnLoansAndDebts +
                  +kyc.morgageCondoFeesRent +
                  +kyc.groceries +
                  +kyc.childCare +
                  +kyc.clothing +
                  +kyc.insurance +
                  +kyc.utilities +
                  +kyc.transportation +
                  +kyc.miscellaneous),
            )}
          </InputRow>

          {/*  Other Contractual Obligations  */}
          <InputRow label={t("Other Contractual Obligations")}>
            <NumberInput
              name={"otherContractualObligations"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              annotationIcon={"$"}
              maxLength={10}
            />
          </InputRow>
        </InputRowGroup>

        {isMaternityForm(kyc) && (
          <>
            {/*  Maternity / Parental Leave  */}
            <InputRowGroup label={t("Maternity / Parental Leave")}>
              {/*  Either parent on maternity/parental leave?  */}
              <InputRow label={t("Either parent on maternity/parental leave?")}>
                <BooleanInput
                  label={t("Yes")}
                  name={"maternityLeave"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                />
              </InputRow>

              {/*  After leave end parent(s) will:  */}
              <InputRow label={t("After leave end parent(s) will:")}>
                <DropdownInput
                  useDefaultValue={false}
                  defaultPlaceholder={t("select option")}
                  name={"afterMaternityLeaveEnds"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                  options={
                    /*
                                        Options:
                                        Return to previous employment
                                        Return to previous employment but with reduced hours
                                        Seek new employment
                                        Not to seek employment
                                        Other (Specify in Notes)
                                         */

                    [
                      {
                        label: t("Return to previous employment"),
                        value: t("Return to previous employment"),
                      },
                      {
                        label: t(
                          "Return to previous employment but with reduced hours",
                        ),
                        value: t(
                          "Return to previous employment but with reduced hours",
                        ),
                      },
                      {
                        label: t("Seek new employment"),
                        value: t("Seek new employment"),
                      },
                      {
                        label: t("Not to seek employment"),
                        value: t("Not to seek employment"),
                      },
                      {
                        label: t("Other (Specify in Notes)"),
                        value: t("Other (Specify in Notes)"),
                      },
                    ]
                  }
                />
              </InputRow>

              {/*  Date by which parent(s) will have returned to work

                            TODO only future
                            */}
              <InputRow
                label={t("Date by which parent(s) will have returned to work")}
              >
                <DateInput
                  name={"returnToWorkDate"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                  minDate={new Date().toISOString().split("T")[0]}
                />
              </InputRow>

              {/*  Savings for RESP during maternity leave  */}
              <InputRow label={t("Savings for RESP during maternity leave")}>
                <NumberInput
                  name={"availableSavingsForRespContributions"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                  onlyAllowPositive={true}
                  onlyAllowInteger={true}
                  annotationIcon={"$"}
                  maxLength={10}
                />
              </InputRow>

              {/*  Location and type of savings */}
              <InputRow label={t("Location and Type of Savings")}>
                <TextInput
                  name={"locationAndTypeOfSavings"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                />
              </InputRow>
            </InputRowGroup>

            {/*  Estimate Monthly Income After Maternity/Parental Leave  */}
            <InputRowGroup
              label={t(
                "Estimate Monthly Income After Maternity/Parental Leave",
              )}
            >
              {/*  Gross and Net Income header */}
              <InputRow label={" "}>
                <div className={"row-with-headers"}>
                  <div>{t("Gross")}</div>
                  <div>{t("Net")}</div>
                </div>
                {/*  TODO find a more elegant way to do this.  */}
              </InputRow>

              {/*  Subscriber1 gross, net income  */}
              <InputRow label={t("Subscriber 1")}>
                <div style={{ display: "flex", gap: "10px" }}>
                  <NumberInput
                    name={"monthlyIncomeGrossAfterMat"}
                    state={subscriber}
                    onChange={handleChange(setSubscriber)}
                    onlyAllowPositive={true}
                    onlyAllowInteger={true}
                    annotationIcon={"$"}
                    maxLength={10}
                  />
                  <NumberInput
                    name={"monthlyIncomeNetAfterMat"}
                    state={subscriber}
                    onChange={handleChange(setSubscriber)}
                    onlyAllowPositive={true}
                    onlyAllowInteger={true}
                    annotationIcon={"$"}
                    maxLength={10}
                  />
                </div>
              </InputRow>

              {/* Subscriber 2 gross, net income */}
              {common.subscriber2Include && (
                <InputRow label={t("Subscriber 2")}>
                  <div style={{ display: "flex", gap: "10px" }}>
                    <NumberInput
                      name={"monthlyIncomeGrossAfterMat"}
                      state={jointSubscriber}
                      onChange={handleChange(setJointSubscriber)}
                      onlyAllowPositive={true}
                      onlyAllowInteger={true}
                      annotationIcon={"$"}
                      maxLength={10}
                    />
                    <NumberInput
                      name={"monthlyIncomeNetAfterMat"}
                      state={jointSubscriber}
                      onChange={handleChange(setJointSubscriber)}
                      onlyAllowPositive={true}
                      onlyAllowInteger={true}
                      annotationIcon={"$"}
                      maxLength={10}
                    />
                  </div>
                </InputRow>
              )}

              {/*  Temporary Income  */}
              <InputRow label={t("CBB")}>
                <NumberInput
                  name={"ccbMonthlyIncomeGrossAfterMat"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                  onlyAllowPositive={true}
                  onlyAllowInteger={true}
                  annotationIcon={"$"}
                  maxLength={10}
                />

                {_displayCurrency(kyc.ccbMonthlyIncomeGrossAfterMat)}
              </InputRow>

              {/*  Other income net and gross  */}
              <InputRow label={t("Other Income")}>
                <div style={{ display: "flex", gap: "10px" }}>
                  <NumberInput
                    name={"otherMonthlyIncomeGrossAfterMat"}
                    state={kyc}
                    onChange={handleChange(setKyc)}
                    onlyAllowPositive={true}
                    onlyAllowInteger={true}
                    annotationIcon={"$"}
                    maxLength={10}
                  />
                  <NumberInput
                    name={"otherMonthlyIncomeNetAfterMat"}
                    state={kyc}
                    onChange={handleChange(setKyc)}
                    onlyAllowPositive={true}
                    onlyAllowInteger={true}
                    annotationIcon={"$"}
                    maxLength={10}
                  />
                </div>
              </InputRow>

              {/*  Estimated Monthly Income  */}
              <InputRow label={t("Estimated Monthly Income")}>
                {/*  TODO remove money added from joint when single is selected  */}
                <div className={"row-with-headers"}>
                  <div>
                    {/*Gross*/}
                    {_displayCurrency(
                      subscriber.monthlyIncomeGrossAfterMat +
                        jointSubscriber.monthlyIncomeGrossAfterMat +
                        kyc.otherMonthlyIncomeGrossAfterMat,
                    )}
                  </div>
                  <div>
                    {/*Net*/}
                    {_displayCurrency(
                      subscriber.monthlyIncomeNetAfterMat +
                        jointSubscriber.monthlyIncomeNetAfterMat +
                        kyc.otherMonthlyIncomeNetAfterMat,
                    )}
                  </div>
                  {/*  TODO find a better way to do this.  */}
                </div>
              </InputRow>

              {/*  Family Yearly Gross Income (Excluding Temp)  */}
              <InputRow label={t("Family Yearly Gross Income")}>
                {/*  TODO figure out how the family yearly gross income is calculated  */}
                <div className={"row-with-headers"}>
                  <div>
                    {_displayCurrency(
                      (subscriber.monthlyIncomeGrossAfterMat +
                        jointSubscriber.monthlyIncomeGrossAfterMat +
                        kyc.otherMonthlyIncomeGrossAfterMat) *
                        12,
                    )}
                  </div>
                </div>
              </InputRow>
            </InputRowGroup>

            {/*  Estimated Monthly Expenses After Maternity/Parental Leave  */}
            <InputRowGroup
              label={t(
                "Estimate Monthly Expenses After Maternity/Parental Leave",
              )}
            >
              {/*  Payments on Loans and Debts */}
              <InputRow label={t("Payments on Loans and Debts")}>
                <NumberInput
                  name={"paymentOnLoansAndDebtsAfterMat"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                  onlyAllowPositive={true}
                  onlyAllowInteger={true}
                  annotationIcon={"$"}
                  maxLength={10}
                />
              </InputRow>

              {/*  Mortgage / Condo fees / Rent / Property Tax */}
              <InputRow
                label={t("Mortgage / Condo fees / Rent / Property Tax")}
              >
                <NumberInput
                  name={"morgageCondoFeesRentAfterMat"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                  onlyAllowPositive={true}
                  onlyAllowInteger={true}
                  annotationIcon={"$"}
                  maxLength={10}
                />
              </InputRow>

              {/*  Groceries  */}
              <InputRow label={t("Groceries")}>
                <NumberInput
                  name={"groceriesAfterMat"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                  onlyAllowPositive={true}
                  onlyAllowInteger={true}
                  annotationIcon={"$"}
                  maxLength={10}
                />
              </InputRow>

              {/*  Child Care  */}
              <InputRow label={t("Child Care")}>
                <NumberInput
                  name={"childCareAfterMat"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                  onlyAllowPositive={true}
                  onlyAllowInteger={true}
                  annotationIcon={"$"}
                  maxLength={10}
                />
              </InputRow>

              {/*  Clothing  */}
              <InputRow label={t("Clothing")}>
                <NumberInput
                  name={"clothingAfterMat"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                  onlyAllowPositive={true}
                  onlyAllowInteger={true}
                  annotationIcon={"$"}
                  maxLength={10}
                />
              </InputRow>

              {/*  Insurance (Life, Property)  */}
              <InputRow label={t("Insurance (Life, Property)")}>
                <NumberInput
                  name={"insuranceAfterMat"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                  onlyAllowPositive={true}
                  onlyAllowInteger={true}
                  annotationIcon={"$"}
                  maxLength={10}
                />
              </InputRow>

              {/*  Utilities  */}
              <InputRow label={t("Utilities")}>
                <NumberInput
                  name={"utilitiesAfterMat"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                  onlyAllowPositive={true}
                  onlyAllowInteger={true}
                  annotationIcon={"$"}
                  maxLength={10}
                />
              </InputRow>

              {/*  Transportation  */}
              <InputRow label={t("Transportation")}>
                <NumberInput
                  name={"transportationAfterMat"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                  onlyAllowPositive={true}
                  onlyAllowInteger={true}
                  annotationIcon={"$"}
                  maxLength={10}
                />
              </InputRow>

              {/*  Miscellaneous (detail in notes)  */}
              <InputRow label={t("Miscellaneous (detail in notes)")}>
                <NumberInput
                  name={"miscellaneousAfterMat"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                  onlyAllowPositive={true}
                  onlyAllowInteger={true}
                  annotationIcon={"$"}
                  maxLength={10}
                />
              </InputRow>

              {/*  Estimated Total Expenses  */}
              <InputRow label={t("Estimated Total Expenses")}>
                {/*  TODO figure out how the estimated total expenses is calculated  */}
                {_displayCurrency(
                  +kyc.paymentOnLoansAndDebtsAfterMat +
                    +kyc.morgageCondoFeesRentAfterMat +
                    +kyc.groceriesAfterMat +
                    +kyc.childCareAfterMat +
                    +kyc.clothingAfterMat +
                    +kyc.insuranceAfterMat +
                    +kyc.utilitiesAfterMat +
                    +kyc.transportationAfterMat +
                    +kyc.miscellaneousAfterMat,
                )}
              </InputRow>
            </InputRowGroup>

            {/*  Estimated Monthly Disposable Income After Maternity/Parental Leave  */}
            <InputRowGroup
              label={t(
                "Estimated Monthly Disposable Income After Maternity/Parental Leave",
              )}
            >
              {/*  Estimated Disposable Income  */}
              <InputRow label={t("Estimated Disposable Income")}>
                {/*  TODO figure out how the estimated disposable income is calculated  */}
                {_displayCurrency(
                  +subscriber.monthlyIncomeNetAfterMat +
                    +jointSubscriber.monthlyIncomeNetAfterMat +
                    +kyc.otherMonthlyIncomeNetAfterMat -
                    (+kyc.paymentOnLoansAndDebtsAfterMat +
                      +kyc.morgageCondoFeesRentAfterMat +
                      +kyc.groceriesAfterMat +
                      +kyc.childCareAfterMat +
                      +kyc.clothingAfterMat +
                      +kyc.insuranceAfterMat +
                      +kyc.utilitiesAfterMat +
                      +kyc.transportationAfterMat +
                      +kyc.miscellaneousAfterMat),
                )}
              </InputRow>
              {/*  Other Contractual Obligations  */}
              <InputRow label={t("Other Contractual Obligations")}>
                <NumberInput
                  name={"otherContractualObligationsAfterMat"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                  onlyAllowPositive={true}
                  onlyAllowInteger={true}
                  annotationIcon={"$"}
                  maxLength={10}
                />
              </InputRow>
            </InputRowGroup>
          </>
        )}

        {/*  Monthly ESP contribution (excluding T-mode) cannot exceed  */}
        <InputRowGroup>
          {/*  Monthly ESP contribution (excluding T-mode) cannot exceed  */}
          <InputRow
            label={t(
              "Monthly ESP contribution (excluding T-mode) cannot exceed",
            )}
          >
            {/*  TODO figure out how the monthly ESP contribution (excluding T-mode) cannot exceed is calculated  */}
            {_displayCurrency(
              (+subscriber.monthlyIncomeNet +
                +jointSubscriber.monthlyIncomeNet +
                +kyc.otherMonthlyIncomeNet -
                (+kyc.paymentOnLoansAndDebts +
                  +kyc.morgageCondoFeesRent +
                  +kyc.groceries +
                  +kyc.childCare +
                  +kyc.clothing +
                  +kyc.insurance +
                  +kyc.utilities +
                  +kyc.transportation +
                  +kyc.miscellaneous) -
                +kyc.otherContractualObligations) *
                0.6,
            )}
          </InputRow>
        </InputRowGroup>

        {/*  Know Your Client Notes  */}
        <InputRowGroup label={t("Know Your Client Notes:")}>
          {/*  Know Your Client Notes  */}
          <MultilineInputRow
            name={"notes"}
            state={kyc}
            onChange={handleChange(setKyc)}
            maxLength={1500}
          />
        </InputRowGroup>

        {/*  dependants  */}
        <InputRowGroup label={t("Dependants")}>
          {/*  Number of Dependants  */}
          <InputRow label={t("Number of Dependants")}>
            <NumberInput
              name={"numberOfDependants"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              maxLength={2}
            />
          </InputRow>

          {/*  Number of Dependants Purchasing Scholarship Plans  */}
          <InputRow
            label={t("Number of Dependants Purchasing Scholarship Plans")}
          >
            <NumberInput
              name={"numberPurchasingScholarshipPlan"}
              state={kyc}
              onChange={handleChange(setKyc)}
              onlyAllowPositive={true}
              onlyAllowInteger={true}
              maxLength={2}
            />
          </InputRow>

          {/*  is this the correct age of the youngest potential beneficiary?  */}
          <InputRow
            label={t(
              "Is this the correct age of the youngest potential beneficiary?",
            )}
          >
            <BooleanInput
              label={t("Yes")}
              name={"ageOfYoungestBeneficiaryDefault"}
              state={kyc}
              onChange={handleChange(setKyc)}
            />
          </InputRow>

          {/*  Age of Youngest Potential Beneficiary  */}
          <InputRow label={t("Age of the youngest potential beneficairy")}>
            {kyc.ageOfYoungestBeneficiaryDefault &&
              calculateAgeOfYoungestBeneficiary(beneficiary, kyc)}
            {!kyc.ageOfYoungestBeneficiaryDefault && (
              <NumberInput
                name={"ageOfYoungestBeneficiary"}
                state={kyc}
                onChange={handleChange(setKyc)}
                onlyAllowPositive={true}
                onlyAllowInteger={true}
              />
            )}
          </InputRow>

          {/*  Time Horizon
           */}
          <InputRow label={t("Time Horizon")}>
            {calculateTimeHorizon(beneficiary, kyc)}
          </InputRow>
        </InputRowGroup>

        {/*  1st Dependant  */}
        {kyc.numberOfDependants >= 1 && (
          <InputRowGroup label={t("1st Dependant")}>
            {/*  Beneficiary is a dependant  */}
            <InputRow label={t("Beneficiary is a dependant")}>
              <BooleanInput
                label={t("Yes")}
                name={"beneficiaryIsADependant"}
                state={kyc}
                onChange={handleChange(setKyc)}
              />
            </InputRow>

            {/*  Name

                        Dropdown

                        TODO find out where to get name
                        */}

            <InputRow label={t("Name")}>
              {/* TODO if the beneficiary is a dependant then must be set to database

                             TODO Need to add dependants to state
                             */}
              {
                kyc.beneficiaryIsADependant &&
                  (beneficiary.firstName === "" && beneficiary.lastName === ""
                    ? "Name of Beneficiary"
                    : beneficiary.firstName + " " + beneficiary.lastName) // TODO if unset then some default...
              }
              {!kyc.beneficiaryIsADependant && (
                <TextInput
                  name={"name"}
                  state={dependant}
                  onChange={handleChange(setDependant)}
                />
              )}
            </InputRow>

            {/*  Birth Date  */}
            <InputRow label={t("Birth Date")}>
              {kyc.beneficiaryIsADependant && beneficiary.birthdate}
              {!kyc.beneficiaryIsADependant && (
                <DateInput
                  name={"birthdate"}
                  state={dependant}
                  onChange={handleChange(setDependant)}
                  maxDate={new Date().toISOString().split("T")[0]}
                />
              )}
            </InputRow>

            {/*  No. of years of educational support */}
            <InputRow label={t("No. of years of educational support")}>
              <DropdownInput
                name={"yearsOfEducationalSupport"}
                state={dependant}
                onChange={handleChange(setDependant)}
                options={yearsEducationalSupport}
              />
            </InputRow>
          </InputRowGroup>
        )}

        {/*  2nd Dependant  */}
        {kyc.numberOfDependants >= 2 && (
          <InputRowGroup label={t("2nd Dependant")}>
            {/*  Name

                        Dropdown
                        */}

            <InputRow label={t("Name")}>
              <TextInput
                name={"name"}
                state={dependant2}
                onChange={handleChange(setDependant2)}
                maxLength={50}
              />
            </InputRow>

            {/*  Birth Date  */}
            <InputRow label={t("Birth Date")}>
              <DateInput
                name={"birthdate"}
                state={dependant2}
                onChange={handleChange(setDependant2)}
                maxDate={new Date().toISOString().split("T")[0]}
              />
            </InputRow>

            {/*  No. of years of educational support
             */}
            <InputRow label={t("No. of years of educational support")}>
              <DropdownInput
                name={"yearsOfEducationalSupport"}
                state={dependant2}
                onChange={handleChange(setDependant2)}
                options={yearsEducationalSupport}
              />
            </InputRow>
          </InputRowGroup>
        )}

        {/*  3rd Dependant  */}
        {kyc.numberOfDependants >= 3 && (
          <InputRowGroup label={t("3rd Dependant")}>
            {/*  Name

                        Dropdown
                        */}

            <InputRow label={t("Name")}>
              <TextInput
                name={"name"}
                state={dependant3}
                onChange={handleChange(setDependant3)}
                maxLength={50}
              />
            </InputRow>

            {/*  Birth Date  */}
            <InputRow label={t("Birth Date")}>
              <DateInput
                name={"birthdate"}
                state={dependant3}
                onChange={handleChange(setDependant3)}
                maxDate={new Date().toISOString().split("T")[0]}
              />
            </InputRow>

            {/*  No. of years of educational support
             */}
            <InputRow label={t("No. of years of educational support")}>
              <DropdownInput
                name={"yearsOfEducationalSupport"}
                state={dependant3}
                onChange={handleChange(setDependant3)}
                options={yearsEducationalSupport}
              />
            </InputRow>
          </InputRowGroup>
        )}

        {/*  4th Dependant  */}
        {kyc.numberOfDependants >= 4 && (
          <InputRowGroup label={t("4th Dependant")}>
            {/*  Name

                        Dropdown
                        */}

            <InputRow label={t("Name")}>
              <TextInput
                name={"name"}
                state={dependant4}
                onChange={handleChange(setDependant4)}
                maxLength={50}
              />
            </InputRow>

            {/*  Birth Date  */}
            <InputRow label={t("Birth Date")}>
              <DateInput
                name={"birthdate"}
                state={dependant4}
                onChange={handleChange(setDependant4)}
                maxDate={new Date().toISOString().split("T")[0]}
              />
            </InputRow>

            {/*  No. of years of educational support
             */}
            <InputRow label={t("No. of years of educational support")}>
              <DropdownInput
                name={"yearsOfEducationalSupport"}
                state={dependant4}
                onChange={handleChange(setDependant4)}
                options={yearsEducationalSupport}
              />
            </InputRow>
          </InputRowGroup>
        )}

        {/*  5th Dependant
                {kyc.numberOfDependants >= 5 && (
                    <InputRowGroup label={t("5th Dependant")}>


                        <InputRow label={t("Name")}>
                            <TextInput
                                name={"name"}
                                state={dependant5}
                                onChange={handleChange(setDependant5)}
                                maxLength={50}
                            />
                        </InputRow>

                        <InputRow label={t("Birth Date")}>
                            <DateInput
                                name={"birthdate"}
                                state={dependant5}
                                onChange={handleChange(setDependant5)}
                                maxDate={new Date().toISOString().split("T")[0]}
                            />
                        </InputRow>

                        <InputRow
                            label={t("No. of years of educational support")}
                        >
                            <DropdownInput
                                name={"yearsOfEducationalSupport"}
                                state={dependant5}
                                onChange={handleChange(setDependant5)}
                                options={yearsEducationalSupport}
                            />
                        </InputRow>
                    </InputRowGroup>
        )
    }
                */}

        {/*  Prospectus  */}
        <InputRowGroup label={t("Prospectus")}>
          {/*  Prospectus Date
                    TODO when clicked give some dates as only options...
                    */}
          <InputRow label={t("Prospectus")}>
            {/*<DateInput*/}
            {/*    name={"prospectusDate"}*/}
            {/*    state={common}*/}
            {/*    onChange={handleChange(setCommon)}*/}
            {/*    datesAllowed={[*/}
            {/*        // only allow june 30th 2023 and june 29st 2024 TODO NOT WORKING!*/}
            {/*        "2023-06-30",*/}
            {/*        "2024-06-29"*/}
            {/*    ]}*/}
            {/*    innerRef={params.item === 'prospectusDate' ? focusRef : null}*/}
            {/*/>*/}

            <DropdownInput
              name={"prospectusDate"}
              state={common}
              onChange={handleChange(setCommon)}
              defaultPlaceholder={t("select date")}
              useDefaultValue={false}
              innerRef={params.item === "prospectusDate" ? focusRef : null}
              options={[
                // {label: "August 12th 2022", value: "2022-08-12"}, // old prospectus date this is only used temporarily during prospectus transition
                { label: "June 20th 2025", value: "2025-06-20" }, // new prospectus date
              ]}
            />
          </InputRow>
        </InputRowGroup>

        {/*  Commitment  */}
        <InputRowGroup label={t("Politically Exposed Person (PEP)")}>
          {/*  Can You Keep Contributions Until Maturity?

                    TODO find where this is stored maybe this is wrong?
                    */}
          <InputRow
            label={t(
              "Are you a Politically Exposed Person (PEP) or Head of an International Organization (HIO)?",
            )}
          >
            <BooleanInput
              label={t("Yes")}
              name={"pepYN"}
              state={kyc}
              onChange={handleChange(setKyc)}
            />
          </InputRow>
        </InputRowGroup>
        <InputRowGroup label={t("Commitment")}>
          {/*  Can You Keep Contributions Until Maturity?

                    TODO find where this is stored maybe this is wrong?
                    */}
          <InputRow label={t("Can you keep contributions until maturity?")}>
            <BooleanInput
              label={t("Yes")}
              name={"anticipateKeepContributions"}
              state={kyc}
              onChange={handleChange(setKyc)}
            />
          </InputRow>
          <InputRow
            label={t(
              "If you were unable to keep the contributions in the plan until maturity, do you have the ability to absorb any loss that may occur?",
            )}
          >
            <BooleanInput
              label={t("Yes")}
              name={"anticipateAbleToKeepContributions"}
              state={kyc}
              onChange={handleChange(setKyc)}
            />
          </InputRow>
        </InputRowGroup>

        {/*  Third party financial support form  */}
        <InputRowGroup label={t("Third Party Financial Support Form")}>
          {/*  Third Party Financial Support


                    TODO make this open another form
                    */}
          <InputRow label={t("Third Party Financial Support Form")}>
            <BooleanInput
              label={t("Yes")}
              name={"thirdPartyFinacialSupportForm"}
              state={kyc}
              onChange={handleChange(setKyc)}
            />
          </InputRow>

          {kyc.thirdPartyFinacialSupportForm && (
            <>
              {/*  Name  */}
              <InputRow label={t("Name")}>
                <TextInput
                  name={"thirdPartyName"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                />
              </InputRow>

              {/*  Date of birth

                            TODO make only valid before today

                            */}
              <InputRow label={t("Date of Birth")}>
                <DateInput
                  name={"thirdPartyBirthdate"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                  maxDate={new Date().toISOString().split("T")[0]}
                />
              </InputRow>

              {/*  Relationship to Subscriber */}
              <InputRow label={t("Relationship to Subscriber")}>
                <TextInput
                  name={"thirdPartyRelationship"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                />
              </InputRow>

              {/*  Home Address  */}
              <InputRow label={t("Home Address")}>
                <TextInput
                  name={"thirdPartyHomeAddress"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                />
              </InputRow>

              {/*  Source of Income  */}
              <InputRow label={t("Source of Income")}>
                <TextInput
                  name={"thirdPartyIncomeSource"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                />
              </InputRow>

              {/*  Annual Income  */}
              <InputRow label={t("Annual Income")}>
                <NumberInput
                  name={"thirdPartyIncome"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                  annotationIcon={"$"}
                />
              </InputRow>

              {/*  Annual Disposable Income  */}
              <InputRow label={t("Annual Disposable Income")}>
                <NumberInput
                  name={"thirdPartyDisposableIncome"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                  onlyAllowPositive={true}
                  onlyAllowInteger={true}
                  annotationIcon={"$"}
                />
              </InputRow>

              {/*  Approximate Net Worth  */}
              <InputRow label={t("Approximate Net Worth")}>
                <NumberInput
                  name={"thirdPartyApproxNetWorth"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                  onlyAllowPositive={true}
                  onlyAllowInteger={true}
                  annotationIcon={"$"}
                />
              </InputRow>

              {/*  Type of ID  */}
              <InputRow label={t("Type of ID")}>
                <TextInput
                  name={"thirdPartyIdType"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                />
              </InputRow>

              {/*  ID Number  */}
              <InputRow label={t("ID Number")}>
                <TextInput
                  name={"thirdPartyIdNumber"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                />
              </InputRow>

              {/*  Expiry Date  */}
              <InputRow label={t("ID Expiry (mm/yy)")}>
                <TextInput
                  name={"thirdPartyIdExpiry"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                />
              </InputRow>

              {/*  When did financial support begin?  */}
              <InputRow label={t("When did financial support begin?")}>
                <TextInput
                  name={"thirdPartyBegin"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                />
              </InputRow>

              {/*  Financial Support Details */}
              <InputRow label={t("Financial Support Details")}>
                <TextInput
                  name={"thirdPartyDetail"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                />
              </InputRow>

              {/*  Agreement in Place?  */}
              <InputRow label={t("Agreement in Place?")}>
                <TextInput
                  name={"thirdPartyDocumentation"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                />
              </InputRow>

              {/*  Date Financial Support will end  */}
              <InputRow label={t("Date Financial Support will end")}>
                <TextInput
                  name={"thirdPartyEndDate"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                />
              </InputRow>

              {/*  Specify why if no end date  */}
              <InputRow label={t("Specify why if no end date")}>
                <TextInput
                  name={"thirdPartyNoEndReason"}
                  state={kyc}
                  onChange={handleChange(setKyc)}
                />
              </InputRow>
              <InputRow label={t("E-Mail Address")}>
                <TextInput
                  placeholder={t("E-Mail Address")}
                  name={"thirdPartyEmail"}
                  state={state.knowYourClient}
                  onChange={handleChange(state.setKnowYourClient)}
                  validationRules={{
                    pattern: {
                      value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                    },
                  }}
                  autoFocus={params.item === "subscriber.email"}
                  validationFailedMessage={
                    "The E-Mail address entered was invalid"
                  }
                />
              </InputRow>

              <InputRow label={t("Mobile Phone Number")}>
                +1
                <TextInput
                  placeholder={t("Mobile Phone Number")}
                  name={"thirdPartyPhone"}
                  state={state.knowYourClient}
                  onChange={handleChange(state.setKnowYourClient)}
                  validationRules={{
                    pattern: {
                      value: /^\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$/,
                    },
                  }}
                  autoFocus={params.item === "subscriber.mobilePhone"}
                  validationFailedMessage={
                    "The phone number entered was invalid"
                  }
                />
                <div className={"info"}>
                  {t(
                    "As a security precaution, a text message may be sent to this number during the signing process to verify the identity of the subscriber.",
                  )}
                </div>
              </InputRow>

              <InputRow label={t("Signing Method")}>
                <DropdownInput
                  name={"thirdPartyInPersonSigner"}
                  state={state.knowYourClient}
                  onChange={handleChange(state.setKnowYourClient)}
                  options={[
                    { label: t("In Person"), value: true },
                    { label: t("Remote"), value: false },
                  ]}
                  booleanValue={true}
                />
              </InputRow>
            </>
          )}
        </InputRowGroup>
      </form>
    );
  }
};

export default KnowYourClientDataCollection;
